<template>
  <div :class="{'sidebar-hidden': !sidebarVisible, 'sidebar-visibe': sidebarVisible, 'user-authenticated': authenticated, 'user-not-authenticated': !authenticated }"
       class="app-layout d-flex flex-column">
    <o-apo-one-navbar v-on:toggle-sidebar="toggleSidebar"></o-apo-one-navbar>
    <div id="content" class="container-fluid col h-100" @click="hideSidebar">
      <div class="row h-100">
        <vue-perfect-scrollbar>
          <o-apo-one-sidebar v-if="authenticated" :visible="sidebarVisible"></o-apo-one-sidebar>
        </vue-perfect-scrollbar>
        <div class="col mw-25">
          <!--<vue-perfect-scrollbar>-->
            <div class="p-4 mb-3 min-vh-80">
              <o-child/>
            </div>
          <!--</vue-perfect-scrollbar>-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#content {
  padding-top: 56px;
}
</style>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import OApoOneNavbar from '../components/ApoOneNavbar.vue'
import OApoOneSidebar from '../components/ApoOneSidebar.vue'

export default {
  name: 'apo_one-layout',

  data: () => ({
    sidebarVisible: true,
    width: window.innerWidth
  }),

  computed: {
    ...mapGetters({
      authenticated: 'auth/check'
    }),
    containerClasses () {
      return ''
      if (this.authenticated) {
        return 'col-sm-12 ml-sm-auto col-md-8 col-lg-9 col-xl-9 pt-0'
      }
      return 'col-sm-12 mx-sm-auto col-md-12 col-lg-10 col-xl-8 pt-0'
    }
  },

  mounted () {
    this.sidebarVisible = this.width > 768
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },

  components: {
    OApoOneSidebar,
    OApoOneNavbar,
    VuePerfectScrollbar
  },

  methods: {
    toggleSidebar () {
      this.sidebarVisible = !this.sidebarVisible
    },
    hideSidebar () {
      if (this.width < 768) {
        this.sidebarVisible = false
      }
    },
    onResize () {
      this.width = window.innerWidth
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
